import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f44a692&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0f44a692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f44a692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f44a692')) {
      api.createRecord('0f44a692', component.options)
    } else {
      api.reload('0f44a692', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f44a692&scoped=true&", function () {
      api.rerender('0f44a692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configurator/index.vue"
export default component.exports